<a class="nav-link text-left" href="javascript:void(0);" (click)="resumeUser()" *ngIf="isSwitched">Resume Session</a>